// FeedbackIconButton.tsx
import { theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { testIdentifiers } from 'utils/testIdentifiers';
import { FeedbackConfig, FeedbackType } from './Feedback';

const styles = StyleSheet.create({
  button: {
    width: 60,
    height: 60,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
  },
  selectedButton: {
    borderColor: 'black',
  },
  unselectedButton: {
    borderColor: 'lightgray',
  },
});

const FeedbackIconButton: React.FC<{
  config: FeedbackConfig;
  selected: string;
  onPress: (id: FeedbackType) => void;
}> = ({ config, selected, onPress }) => {
  const { t } = useTranslation();

  const isSelected = selected === config.id;

  const getAccessibilityLabel = () => {
    const feedbackType = t(`ariaLabels.feedback.${config.id.toLowerCase()}`);
    const selectionState = isSelected ? t('common.selected') : '';
    let result = feedbackType;
    if (selectionState) {
      result += ', ' + selectionState;
    }
    return result;
  };

  return (
    <TouchableOpacity
      accessibilityRole="button"
      accessibilityState={{ selected: isSelected }}
      accessibilityLabel={getAccessibilityLabel()}
      {...testIdentifiers(`feedback-icon-${config.id}`)}
      style={[
        styles.button,
        isSelected ? styles.selectedButton : styles.unselectedButton,
      ]}
      onPress={() => onPress(config.id)}>
      <Icon name={config.icon} color={theme.colors.white} />
    </TouchableOpacity>
  );
};

export default FeedbackIconButton;
